import DateDefault from '../views/dataAnalysis/dataDeafult/default.vue';

export default [
  {
    path: '/dataAnalysisLogin',
    name: 'dataAnalysisLogin',
    component: () => import(/* webpackChunkName: 'dataAnalysisLogin' */ '../views/dataAnalysis/login/index.vue'),
  },
  {
    path: '/dataDefault',
    component: DateDefault,
    children: [
      {
        name: 'projectProgress',
        path: 'progress',
        component: () => import(/* webpackChunkName: 'projectProgress' */ '../views/dataAnalysis/projectProgress/index.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        name: 'projectData',
        path: 'data',
        component: () => import(/* webpackChunkName: 'projectData' */ '../views/dataAnalysis/projectData/index.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        name: 'personalInformationList',
        path: 'personalInformationList',
        component: () => import(
          /* webpackChunkName: 'personalInformationList' */
          '../views/dataAnalysis/personalInformationList/index.vue'),
        meta: {
          keepAlive: true,
        },
      },
      {
        name: 'personalInformationDetails',
        path: 'personalInformationDetails',
        component: () => import(
          /* webpackChunkName: 'personalInformationDetails' */
          '../views/dataAnalysis/personalInformationDetails/index.vue'),
      },
      {
        name: 'projectDetail',
        path: 'projectDetail',
        component: () => import(/* webpackChunkName: 'projectDetail' */ '../views/dataAnalysis/projectDetail/index.vue'),
      },
      {
        name: 'projectList',
        path: 'projectList',
        component: () => import(/* webpackChunkName: 'projectList' */ '../views/dataAnalysis/projectList/index.vue'),
      },
    ],
  },
];
